/** Shown when POST /api/ai/chat returns 409 `ai_chat_busy` (request lock still held). */
export const AI_CHAT_BUSY_MESSAGE =
  "Der Assistent arbeitet noch an der vorherigen Anfrage. Bitte warte, bis die aktuelle Antwort fertig ist.";

/**
 * Honest copy after the user stops watching a turn. Generation is not cancelled.
 * One line, no box — rendered as muted helper text.
 */
export const BACKGROUND_TURN_DISMISSED_HINT =
  "Die Antwort wird im Hintergrund fertig geschrieben und erscheint, wenn du den Chat das nächste Mal öffnest.";

export function messageForChatHttpError(
  status: number,
  bodyText: string,
): { message: string; busy: boolean } {
  let error: string | undefined;
  let code: string | undefined;
  try {
    const parsed = JSON.parse(bodyText) as { error?: unknown; code?: unknown };
    if (typeof parsed.error === "string" && parsed.error.trim()) error = parsed.error.trim();
    if (typeof parsed.code === "string" && parsed.code.trim()) code = parsed.code.trim();
  } catch {
    /* plain text body */
  }
  const fallback = bodyText.trim();
  if (status === 409 && (code === "ai_chat_busy" || !code)) {
    return { message: error || AI_CHAT_BUSY_MESSAGE, busy: true };
  }
  return {
    message: error || fallback || "Ich konnte die Chat-Antwort nicht laden.",
    busy: false,
  };
}
